// Must match App.js updateMerchant STEP_ORDER for activation / onboarding progression.
const STEP_ORDER = [
  'invite_team_pre_form',
  'create_form',
  'stripe_connect',
  'script_install',
  'share',
  'awaiting_stripe_charges',
  'checklist',
  'education',
  'complete',
];

/**
 * True only for the minimal router seed from SignupFlow (before GET /merchant replaces state).
 * Do NOT infer from organizationId/!id — V2 API flatten omits top-level `id` on purpose (see org_utils
 * flatten_v2_to_v1_compat: v1_key 'id' is skipped), so real GET payloads also have no `id`.
 */
export function isRouterMerchantSeedPendingHydration(merchant) {
  return merchant?.__charitystackRouterSeed === true;
}

/** Past pre-form invite by durable merchant fields (survives brief stale invite_team_pre_form on GET). */
export function isPreFormInviteDurableComplete(merchant) {
  const completed = merchant?.onboardingCompletedSteps;
  if (Array.isArray(completed) && completed.includes('invite_team')) return true;
  if (merchant?.driverFlowsCompleted?.guidedFormTour === true) return true;
  const step = merchant?.onboardingCurrentStep;
  const idx = STEP_ORDER.indexOf(step);
  const inviteIdx = STEP_ORDER.indexOf('invite_team_pre_form');
  return idx !== -1 && idx > inviteIdx;
}
